<template>
  <v-layout>
    <v-main>
      <v-container class="">
        <v-card>
          <v-row>
            <v-col>

              <v-sheet class="ma-2 pa-2">
                <div class="pa-2 text-h3">Zuchtkatzen</div>
              </v-sheet>
              <v-sheet v-if="catFilter(false, false).length > 0" class="ma-2 pa-2">
                <div class="pa-2 text-h5">Katzen</div>
                <v-col v-for="item in catFilter(false, false)" :key="item.id" :to="item.link">
                  <cat-card :cat="item"></cat-card>
                </v-col>
              </v-sheet>

              <v-sheet v-if="catFilter(false, true).length > 0" class="ma-2 pa-2">
                <div class="pa-2 text-h5">Kater</div>
                <v-col v-for="item in catFilter(false, true)" :key="item.id" :to="item.link">
                  <cat-card :cat="item"></cat-card>
                </v-col>
              </v-sheet>

              <v-sheet class="ma-2 pa-2">
                <div class="pa-2 text-h3">Kastraten</div>
              </v-sheet>

              <v-sheet v-if="catFilter(true, false).length > 0" class="ma-2 pa-2">
                <div class="pa-2 text-h5">Katzen</div>
                <v-col v-for="item in catFilter(true, false)" :key="item.id" :to="item.link">
                  <cat-card :cat="item"></cat-card>
                </v-col>
              </v-sheet>


              <v-sheet v-if="catFilter(true, true).length > 0" class="ma-2 pa-2">
                <div class="pa-2 text-h5">Kater</div>
                <v-col v-for="item in catFilter(true, true)" :key="item.id" :to="item.link">
                  <cat-card :cat="item"></cat-card>
                </v-col>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-main>
  </v-layout>
  <br />
  <br />
</template>

<script>
import { useWuerfeStore } from "../store/wuerfe"
import CatCard from "../components/CatCard.vue";

export default {
  components: {
    CatCard,
  },
  setup() {
    const wuerfeStore = useWuerfeStore();
    return { wuerfeStore };
  },
  computed: {
  },
  created() {
    this.updateCatsData();
  },
  beforeUpdate() {
    this.updateCatsData();
  },
  methods: {
    updateCatsData() {
      let catsData = this.wuerfeStore.cats;
      this.catsData = catsData;
    },
    profileImageThumbLink(catname) {
      if (process.env.NODE_ENV === 'development') {
        return require("@/assets/static/katzendetails/thumb." + catname + ".png");
      } else {
        return "https://static.jokingheroes.de/katzendetails/thumb." + catname + ".png";
      }
    },
    catFilter(neutered, male) {
      let output = [];

      for (const name in this.catsData) {
        const m = this.catsData[name].sire === male;
        const n = this.catsData[name].neutered === neutered;
        const o = this.catsData[name].own === true;

        if (m && n && o) {
          output.push(this.catsData[name])
        }
      }

      output.sort((a, b) => a.birthday - b.birthday);

      return output
    },
  },
  data: () => ({
    catsData: {},
  }),
}
</script>
